<ng-container *ngIf="reordered">
    <span class="correspondence-status correspondence-status-{{isLtr ? 'right' : 'left'}}"
        [ngClass]="transformationClass"
        [popover]="manyToOne"
        containerClass="confirmation-popover"
        container="body"
        triggers="click"
        containerClass="many-to-one-popover"
        placement="{{isLtr ? 'right' : 'left'}}"
        [outsideClick]="true"
        #pop="bs-popover"></span>
    <ng-template #manyToOne>
        <div (mouseleave)="pop.hide();">
            <ng-container *ngFor="let line of lines | sortBy:'asc':'order'; let last = last">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb py-1 px-2 {{last ? 'mb-0' : ''}}">
                        <li *ngIf="isLtr" class="breadcrumb-item active"><small>{{line.field?.fieldName || line.field?.label}}</small></li>
                        <li *ngIf="!isLtr" class="breadcrumb-item active"><small>{{line.input?.name}}</small></li>
                        <li><span class="badge badge-pill badge-info mx-2"><i class="fas fa-arrow-right"></i></span></li>
                        <li *ngIf="isLtr" class="breadcrumb-item active mr-2"><small>{{line.input?.name}}</small></li>
                        <li *ngIf="!isLtr" class="breadcrumb-item active mr-2"><small>{{line.field?.fieldName || line.field?.label}}</small></li>
                        <li class="ml-auto"><small tooltip="{{'Add modifiers' | translate}}" placement="right" container="body" (click)="setLine(line); pop.hide();" [ngClass]="checkLineTransformations(line) ? 'has-value' : ''" class="open-button"><i class="fad fa-sliders"></i></small></li>
                        <li class="ml-2"><small tooltip="{{'Delete link' | translate}}" placement="right" container="body" (click)="delLine(line); pop.hide();"><i class="removeline fal fa-times btn-xs btn-bordered btn-icon flow-remove-icon d-inline-block position-relative"></i></small></li>
                    </ol>
                </nav>
            </ng-container>
        </div>
    </ng-template>
</ng-container>